import { AudienceUserExtended } from '../models/audience-user.extended.model';

export class AddAudienceUsers {
    static readonly type = '[AudienceUser] AddAudienceUsers';

    constructor(public payload: AudienceUserExtended[]) {}
}
